import {CelebrationsReportDuration} from "@irati/types"

const buildMonthAndDurationFields = (updatedDuration: string) => {
  const time = updatedDuration.split("-")
  const month = time.length > 1 ? {month: parseInt(time[0], 10), year: parseInt(time[1], 10)} : undefined
  const duration = time.length > 1 ? CelebrationsReportDuration.CelebrationsMonth : updatedDuration
  return {month, duration}
}

export default buildMonthAndDurationFields
